import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { observer } from "mobx-react";

import { PisValues, CofinsValues, OriginValues } from "core/enum";

import {
  DescriptionField,
  SelectField,
  CheckBox,
  If
} from "components/support";

import Tooltip from "material-ui-next/Tooltip";
import Icon from "material-ui-next/Icon";

import { colors } from "assets";

class FiscalInfo extends Component {
  render() {
    const { product } = this.props;
    const taxes = product.taxes || {};

    return (
      <div className="grid-container mt-sm mb-sm">
        <Row>
          <Col xs={12}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <CheckBox
                  disabled
                  checked={taxes.use_default_configuration}
                  label="Configuração Geral"
                  style={{
                    padding: "10px 4px 0px"
                  }}
                />
              </div>
              <div style={{ padding: "6px 0 0 6px" }}>
                <Tooltip
                  key="tooltip-right"
                  title="Acesse a Área do Contador para modificar a Configuração Geral."
                  placement="right"
                >
                  <Icon style={{ color: colors.primary.dark }}>info</Icon>
                </Tooltip>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="NCM (Código do Mercosul)"
              value={taxes.ncm}
              mask={[/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/]}
            />
          </Col>
          <If test={!taxes.use_default_configuration}>
            <Col xs={12} sm={6}>
              <DescriptionField
                label="CFOP"
                value={taxes.cfop}
                mask={[/\d/, ".", /\d/, /\d/, /\d/]}
              />
            </Col>
          </If>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="CEST"
              value={taxes.cest}
              mask={[/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/]}
            />
          </Col>
          <If test={!taxes.use_default_configuration}>
            <Col xs={12} sm={6}>
              <DescriptionField label="CSOSN" value={taxes.csosn} />
            </Col>
          </If>
          <If test={!taxes.use_default_configuration}>
            <Col xs={12} sm={6}>
              <SelectField
                fullWidth
                disabled
                options={PisValues}
                value={taxes.pis}
                errorText={product.errors.pis}
                label="PIS"
              />
            </Col>
            <Col xs={12} sm={6}>
              <SelectField
                fullWidth
                disabled
                options={CofinsValues}
                value={taxes.cofins}
                errorText={product.errors.cofins}
                label="COFINS"
              />
            </Col>
            <Col xs={12}>
              <SelectField
                fullWidth
                disabled
                options={OriginValues}
                value={taxes.origin}
                errorText={product.errors.origin}
                label="ORIGEM"
              />
            </Col>
          </If>
        </Row>
      </div>
    );
  }
}

export default observer(FiscalInfo);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/info/fiscal-info/index.jsx